module.exports = __webpack_public_path__ + "img/744.9ae0151f.jpg";